import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { get_job_details_hiring_manager_action } from "../../../redux/_actions/hiringManager";

function useHiringManagerCreateJob(props) {
  const [jobTitle, setJobTitle] = useState("");
  const [jobDetails, setJobDetails] = useState();
  const [loading, setloading] = useState(false);
  const [closeJobModal, setCloseJobModal] = useState(false);

  const dispatch = useDispatch();
  const params = useParams();

  const { jobTitleInRedux } = useSelector(
    (state) => state.set_job_title_hiring_manager_reducer
  );

  const { jobDetailsData } = useSelector(
    (state) => state.get_job_details_hiring_manager_reducer
  );
  const jobDetailsRef = useRef();

  //get job details of current job
  useEffect(() => {
    let job_id = params?.id;
    if (job_id) {
      callApi(job_id);
    }
  }, []);

  useEffect(() => {
    let job_id = params?.id;
    if (job_id) {
      setJobDetails(jobDetailsData?.data);
    }
  }, []);
  // get current job details
  const callApi = async (job_id) => {
    setloading(true);
    await dispatch(get_job_details_hiring_manager_action(job_id));
    setloading(false);
  };

  useEffect(() => {
    if (jobTitleInRedux?.data) {
      const data = jobTitleInRedux?.data;
      setJobTitle(data);
    }
  }, [jobTitleInRedux]);


  const closeJobModalOpenHandler = (type) => {
    setCloseJobModal(type);
    setJobTitle("");
  };

  return {
    jobDetailsRef,
    jobTitle,
    closeJobModal,
    jobDetails,
    closeJobModalOpenHandler,
  };
}
export default useHiringManagerCreateJob;
